// Líneas de producción (Vertical 1, Atlanta 2, etc.).
// Mirror de la tabla `lineas` (migración 00002).
//
// Nota: las capacidades estándar viven en `skus_lineas` (por SKU + línea), NO
// acá. Acá solo la metadata estructural.
import { z } from 'zod';
export const lineaSchema = z.object({
    id: z.string().uuid(),
    tenant_id: z.string().uuid(),
    planta_id: z.string().uuid(),
    area_id: z.string().uuid(),
    nombre: z.string().trim().min(1).max(120),
    codigo: z.string().trim().min(1).max(40),
    activa: z.boolean(),
    /** Línea contenedora de tiendas (captura por corrida, no hora a hora).
     *  Opcional: solo los endpoints que lo necesitan lo exponen. */
    es_tienda: z.boolean().optional(),
});
//# sourceMappingURL=linea.js.map